import InputAccordion from "./InputAccordion";
export default InputAccordion;
